import * as React from "react";
const SvgEyeClosed = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.5001 15L11.8984 12.2917", stroke: "#8D8D8D", style: {
  stroke: "#8D8D8D",
  stroke: "color(display-p3 0.5529 0.5529 0.5529)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.66699 6.66669C2.29062 8.37567 3.4246 9.8516 4.91524 10.8944C6.40589 11.9373 8.18111 12.4966 10.0003 12.4966C11.8195 12.4966 13.5948 11.9373 15.0854 10.8944C16.5761 9.8516 17.71 8.37567 18.3337 6.66669", stroke: "#8D8D8D", style: {
  stroke: "#8D8D8D",
  stroke: "color(display-p3 0.5529 0.5529 0.5529)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16.6668 12.5L15.2285 10.7917", stroke: "#8D8D8D", style: {
  stroke: "#8D8D8D",
  stroke: "color(display-p3 0.5529 0.5529 0.5529)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.33301 12.5L4.77134 10.7917", stroke: "#8D8D8D", style: {
  stroke: "#8D8D8D",
  stroke: "color(display-p3 0.5529 0.5529 0.5529)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.5 15L8.10167 12.2917", stroke: "#8D8D8D", style: {
  stroke: "#8D8D8D",
  stroke: "color(display-p3 0.5529 0.5529 0.5529)",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgEyeClosed;
